import { createContext, useContext, useState, ReactNode } from "react";
import { bookingType } from "data/types";

// Define the context type
interface BookingContextType {
  bookingState: bookingType;
  setBookingState: React.Dispatch<React.SetStateAction<bookingType>>;
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

// Create context with the proper type and default value as undefined
const BookingContext = createContext<BookingContextType | undefined>(undefined);

export const useBooking = () => {
  const context = useContext(BookingContext);
  if (!context) {
    throw new Error("useBooking must be used within a BookingProvider");
  }
  return context;
};

interface BookingProviderProps {
  children: ReactNode;
}

export const BookingProvider = ({ children }: BookingProviderProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [bookingState, setBookingState] = useState<bookingType>({
    locations: [""],
    timezone: "America/New_York",
    currency: "",
    listingId: "",
    startingPrice: null,
    imgUrl: "",
    title: "",
    beds: 0,
    bath: 0,
    city: "",
    state: "",
    searchParams: {
      guests: 2,
    },
    searchResults: {
      totalAvailabilities: 0,
    },
  });

  return (
    <BookingContext.Provider value={{ bookingState, setBookingState, isLoading, setIsLoading }}>
      {children}
    </BookingContext.Provider>
  );
};